import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import renderSelectField from "../../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../../shared/components/form/MultiSelect";
import { Field, reduxForm } from "redux-form";
import { withTranslation } from "react-i18next";
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import { Col, Row, Card } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { withStyles } from "@material-ui/core/styles";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Chip from '@material-ui/core/Chip';

const CHIP_MAX_WIDTH = 100;
const CHIP_ICON_WIDTH = 10;
const EllipsisText = props => {
    const { children } = props;

    return (
        <div
            style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: CHIP_MAX_WIDTH - CHIP_ICON_WIDTH
            }}
        >
            {children}
        </div>
    );
};

const MedicalRadio = withStyles({
    root: {
        color: '#4CE1B6',
        '&$checked': {
            color: '#4CE1B6',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

class Habits extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        console.log("MIN", typeof moment(this.props.dataPatient !== null && this.props.dataPatient !== undefined ? this.props.dataPatient.birthday : '1900-04-06T01:05:00.000Z').format('YYYY'));
        console.log("MAX", typeof moment().format('YYYY'));
    }

    render() {
        const minDate = parseInt(moment(this.props.dataPatient !== null && this.props.dataPatient !== undefined ? this.props.dataPatient.birthday : '1900-04-06T01:05:00.000Z').format('YYYY'));
        const maxDate = parseInt(moment().format('YYYY'));

        return (
            <Card>
                <div>
                    <div className="card__title">
                        <h5 className="bold-text">Información de tabaco</h5>
                    </div>

                </div>

                {this.props.sectionAilment.habits.smoke === "Actual" || this.props.sectionAilment.habits.smoke === "Exfumador" ?
                    <div className="habits-section-smoke">
                        <div className="element-smoke"><p><b>Riesgo leve: menor a 20 IPA</b></p></div>
                        <div className="element-smoke"><p><b>Riesgo moderado: 21 - 40 IPA</b></p></div>
                        <div className="element-smoke"><p><b>Riesgo alto: mayor a 41 IPA</b></p></div>
                    </div>
                    : null}
                <Row>
                    <Col md={3}>
                        <TextField
                            label="Fumador"
                            className="medical-material-form__field"
                            style={{ width: '100%' }}
                            disabled={this.props.stateClinicHistory}
                            select
                            value={this.props.sectionAilment.habits.smoke}
                            onChange={(e) => {
                                this.props.handlerHabits("smoke", e.target.value);
                            }}
                        >
                            <MenuItem key={0} value={'No'}>No</MenuItem>
                            <MenuItem key={1} value={'Exfumador'}>Ex Fumador</MenuItem>
                            <MenuItem key={2} value={'Actual'}>Fumador Actual</MenuItem>
                        </TextField>
                    </Col>
                    {this.props.sectionAilment.habits.smoke === "Actual" || this.props.sectionAilment.habits.smoke === "Exfumador" ?
                        <>
                            <Col md={3} xs={12}>
                                <div className="habits-section-fields">
                                    <div className="element-field">
                                        <TextField
                                            label="Año Inicio"
                                            className="medical-material-form__field"
                                            disabled={this.props.stateClinicHistory}
                                            type="number"
                                            defaultValue={minDate}
                                            //InputProps={{ inputProps: { min: minDate, max: maxDate } }}
                                            style={{ width: '100%' }}
                                            value={this.props.sectionAilment.habits.yearStart}
                                            onChange={(e) => {
                                                this.props.handlerHabits("yearStart", e.target.value);
                                            }}
                                        />
                                    </div>
                                    {this.props.sectionAilment.habits.smoke === "Exfumador" ?
                                        <div className="element-field">
                                            <TextField
                                                label="Año Fin"
                                                className="medical-material-form__field"
                                                type="number"
                                                defaultValue={maxDate}
                                                //InputProps={{ inputProps: { min: minDate, max: maxDate } }}
                                                disabled={this.props.stateClinicHistory}
                                                style={{ width: '100%' }}
                                                value={this.props.sectionAilment.habits.yearEnd}
                                                onChange={(e) => {
                                                    this.props.handlerHabits("yearEnd", e.target.value);
                                                }}
                                            />
                                        </div>
                                        : null}
                                </div>
                            </Col>

                            <Col md={3}>
                                <TextField
                                    label="Cigarrillos por Dia"
                                    className="medical-material-form__field"
                                    type="number"
                                    disabled={this.props.stateClinicHistory}
                                    style={{ width: '100%' }}
                                    value={this.props.sectionAilment.habits.cigarretsPerDay}
                                    onChange={(e) => {
                                        this.props.calculateSmoke(e.target.value);
                                    }}
                                />

                            </Col>
                            <Col md={3}>
                                <TextField
                                    label="Indice de cigarillos por año"
                                    className="medical-material-form__field"
                                    type="number"
                                    style={{ width: '100%' }}
                                    value={this.props.sectionAilment.habits.packegesPerYear}
                                    disabled={true}
                                />
                            </Col>

                        </>
                        : null}
                </Row>
                <br />
                <div>
                    <div className="card__title">
                        <h5 className="bold-text">Información de Exposición</h5>
                    </div>

                </div>
                <Row>
                    <Col md={3}>
                        <TextField
                            label="Exposición al Humo de Leña"
                            className="medical-material-form__field"
                            style={{ width: '100%' }}
                            disabled={this.props.stateClinicHistory}
                            select
                            value={this.props.sectionAilment.habits.firewood}
                            onChange={(e) => {
                                this.props.handlerHabits("firewood", e.target.value);
                            }}
                        >
                            <MenuItem key={0} value={'Si'}>Si</MenuItem>
                            <MenuItem key={1} value={'No'}>No</MenuItem>
                        </TextField>
                    </Col>
                    {this.props.sectionAilment.habits.firewood === "Si" ?
                        <Col md={3}>
                            <TextField
                                disabled={this.props.stateClinicHistory}
                                label="Años de Exposición"
                                className="medical-material-form__field"
                                style={{ width: '100%' }}
                                type="number"
                                value={this.props.sectionAilment.habits.years}
                                onChange={(e) => {
                                    this.props.handlerHabits("years", e.target.value)
                                }}
                            /> </Col> : null}
                </Row>
                <br />
                <div>
                    <div className="card__title">
                        <h5 className="bold-text">Información de sustancias psicoactivas</h5>
                    </div>

                    <Row>
                        <Col md={3}>
                            <FormControl component="fieldset" >
                                <FormLabel style={{ color: '#787A84' }} disabled={true}>Consumo de Sustancias psicoactivas</FormLabel>
                                <RadioGroup
                                    onChange={(e) => {
                                        this.props.handlerHabits("comsuption", e.target.value);
                                    }}
                                    row aria-label="position"
                                    id="radio-habits-drugs"
                                    name="radio-habits-drugs"
                                    value={this.props.sectionAilment.habits.comsuption}
                                >
                                    <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                    <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                </RadioGroup>
                            </FormControl>
                        </Col>
                        {this.props.sectionAilment.habits.comsuption === "Si" ?
                            <>
                                <Col md={3}>
                                    <TextField
                                        label="Frecuencia"
                                        className="medical-material-form__field"
                                        style={{ width: '100%' }}
                                        select
                                        disabled={this.props.stateClinicHistory}
                                        value={this.props.sectionAilment.habits.frecuency}
                                        onChange={(e) => {
                                            this.props.handlerHabits("frecuency", e.target.value);
                                        }}
                                    >
                                        <MenuItem key={0} value={'Diaria'}>Diaria</MenuItem>
                                        <MenuItem key={1} value={'Semanal'}>Semanal</MenuItem>
                                        <MenuItem key={2} value={'Mensual'}>Mensual</MenuItem>
                                    </TextField>
                                </Col>
                                <Col md={3}>
                                    <FormControl className="medical-material-form__field">
                                        <InputLabel required id="demo-simple-select-label">Sustancias</InputLabel>
                                        <Select
                                            multiple
                                            disabled={this.props.stateClinicHistory}
                                            style={{ width: '100%' }}
                                            value={this.props.sectionAilment.habits.substaces}
                                            onChange={(e) => {
                                                this.props.handlerHabits("substaces", e.target.value);
                                            }}
                                            renderValue={(selected) => (
                                                <div>
                                                    {selected.map((drug, index) => (
                                                        <Chip
                                                            size="small"
                                                            label={
                                                                <EllipsisText>
                                                                    {drug}
                                                                </EllipsisText>
                                                            }
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                        >
                                            <MenuItem key={0} value={'Cocaina'}>Cocaina</MenuItem>
                                            <MenuItem key={1} value={'Bazuco'}>Bazuco</MenuItem>
                                            <MenuItem key={2} value={'Extasis'}>Extasis</MenuItem>
                                            <MenuItem key={3} value={'Heroina'}>Heroina</MenuItem>
                                            <MenuItem key={4} value={'LSD'}>LSD</MenuItem>
                                            <MenuItem key={5} value={'Hongos'}>Hongos</MenuItem>
                                            <MenuItem key={6} value={'Marihuana'}>Marihuana</MenuItem>
                                            <MenuItem key={7} value={'GHB'}>GHB</MenuItem>
                                        </Select>
                                        <FormHelperText></FormHelperText>
                                    </FormControl>
                                </Col>
                                <Col md={3}>
                                    <TextField
                                        disabled={this.props.stateClinicHistory}
                                        label="Otra sustancia"
                                        className="medical-material-form__field"
                                        style={{ width: '100%' }}
                                        value={this.props.sectionAilment.habits.substace}
                                        onChange={(e) => {
                                            this.props.handlerHabits("substace", e.target.value);
                                        }}
                                    />
                                </Col>
                            </> : null
                        }
                    </Row>
                </div>
                <br />
                <div>
                    <div className="card__title">
                        <h5 className="bold-text">Información Consumo de Licor</h5>
                    </div>
                    <Row>
                        <Col md={3}>
                            <FormControl component="fieldset" >
                                <FormLabel style={{ color: '#787A84' }} disabled={true}>Consumo de Alcohol</FormLabel>
                                <RadioGroup
                                    onChange={(e) => {
                                        this.props.handlerHabits("alcohol", e.target.value);
                                    }}
                                    row aria-label="position"
                                    id="radio-habits-alcohol"
                                    name="radio-habits-alcohol"
                                    value={this.props.sectionAilment.habits.alcohol}
                                >
                                    <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                    <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                </RadioGroup>
                            </FormControl>
                        </Col>
                        {this.props.sectionAilment.habits.alcohol === "Si" ?
                            <Col md={3}>
                                <TextField
                                    label="En el ultimo año?"
                                    className="medical-material-form__field"
                                    style={{ width: '100%' }}
                                    select
                                    disabled={this.props.stateClinicHistory}
                                    value={this.props.sectionAilment.habits.alcoholLastYear}
                                    onChange={(e) => {
                                        this.props.handlerHabits("alcoholLastYear", e.target.value);
                                    }}
                                >
                                    <MenuItem key={1} value={'Si'}>Si</MenuItem>
                                    <MenuItem key={2} value={'No'}>No</MenuItem>
                                </TextField>
                            </Col>
                            : null
                        }
                        {this.props.sectionAilment.habits.alcohol === "Si" ?
                            <Col md={3}>
                                <TextField
                                    label="Frecuencia de Consumo de Alcohol?"
                                    className="medical-material-form__field"
                                    style={{ width: '100%' }}
                                    select
                                    disabled={this.props.stateClinicHistory}
                                    value={this.props.sectionAilment.habits.frecuencyAlcohol}
                                    onChange={(e) => {
                                        this.props.handlerHabits("frecuencyAlcohol", e.target.value);
                                    }}
                                >
                                    <MenuItem key={0} value={'Diaria'}>Diaria</MenuItem>
                                    <MenuItem key={1} value={'Semanal'}>Semanal</MenuItem>
                                    <MenuItem key={2} value={'Mensual'}>Mensual</MenuItem>
                                    <MenuItem key={3} value={'Ocasionalmente'}>Ocasionalmente</MenuItem>
                                </TextField>
                            </Col>
                            : null
                        }
                    </Row>
                </div>
                <br />
                <div>
                    <div className="card__title">
                        <h5 className="bold-text">
                            Información de Actividades Físicas
                        </h5>
                    </div>
                    <Row>
                        <Col md={3}>
                            <FormControl component="fieldset" >
                                <FormLabel style={{ color: '#787A84' }} disabled={true}>Practica Actividad Fisica</FormLabel>
                                <RadioGroup
                                    onChange={(e) => {
                                        this.props.handlerHabits("physicalActivity", e.target.value);
                                    }}
                                    row aria-label="position"
                                    id="radio-habits-physicalActivity"
                                    name="radio-habits-physicalActivity"
                                    value={this.props.sectionAilment.habits.physicalActivity}
                                >
                                    <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                    <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                </RadioGroup>
                            </FormControl>
                        </Col>
                        {this.props.sectionAilment.habits.physicalActivity === "Si" ?
                            <>
                                <Col md={3}>
                                    <TextField
                                        label="Frecuencia de Actividad Fisica?"
                                        className="medical-material-form__field"
                                        style={{ width: '100%' }}
                                        select
                                        disabled={this.props.stateClinicHistory}
                                        value={this.props.sectionAilment.habits.frecuencyPhysicalActivity}
                                        onChange={(e) => {
                                            this.props.handlerHabits("frecuencyPhysicalActivity", e.target.value);
                                        }}
                                    >
                                        <MenuItem key={0} value={'Diaria'}>Diaria</MenuItem>
                                        <MenuItem key={1} value={'Semanal'}>Semanal</MenuItem>
                                        <MenuItem key={2} value={'Mensual'}>Mensual</MenuItem>
                                    </TextField>
                                </Col>
                                <Col md={3}>
                                    <TextField
                                        label="Tiempo / Duración"
                                        className="medical-material-form__field"
                                        style={{ width: '100%' }}
                                        select
                                        disabled={this.props.stateClinicHistory}
                                        value={this.props.sectionAilment.habits.timePhysicalActivity}
                                        onChange={(e) => {
                                            this.props.handlerHabits("timePhysicalActivity", e.target.value);
                                        }}
                                    >
                                        <MenuItem key={0} value={'30 Minutos'}>30 Minutos</MenuItem>
                                        <MenuItem key={1} value={'45 Minutos'}>45 Minutos</MenuItem>
                                        <MenuItem key={2} value={'1 Hora'}>1 Hora</MenuItem>
                                        <MenuItem key={2} value={'1:30 hora'}>1:30 Hora</MenuItem>
                                        <MenuItem key={2} value={'2 horas'}>2 Horas</MenuItem>
                                        <MenuItem key={2} value={'más de 2 horas'}>Mas de 2 Horas</MenuItem>
                                    </TextField>
                                </Col>
                                <Col md={3}>
                                    <FormControl className="medical-material-form__field">
                                        <InputLabel required id="sports-txt">Cuales?</InputLabel>
                                        <Select
                                            disabled={this.props.stateClinicHistory}
                                            multiple
                                            style={{ width: '100%' }}
                                            value={this.props.sectionAilment.habits.activities}
                                            onChange={(e) => {
                                                this.props.handlerHabits("activities", e.target.value);
                                            }}
                                            renderValue={(selected) => (
                                                <div>
                                                    {selected.map((sport, index) => (
                                                        <Chip
                                                            size="small"
                                                            label={
                                                                <EllipsisText>
                                                                    {sport}
                                                                </EllipsisText>
                                                            }
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                        >
                                            <MenuItem key={0} value={'Gimnasio'}>Gimnasio</MenuItem>
                                            <MenuItem key={1} value={'Futbol'}>Futbol</MenuItem>
                                            <MenuItem key={2} value={'Ciclismo'}>Ciclismo</MenuItem>
                                            <MenuItem key={3} value={'Baloncesto'}>Baloncesto</MenuItem>
                                            <MenuItem key={4} value={'Natacion'}>Natacion</MenuItem>
                                            <MenuItem key={5} value={'Atletismo'}>Atletismo</MenuItem>
                                            <MenuItem key={6} value={'Voleibol'}>Voleibol</MenuItem>
                                            <MenuItem key={7} value={'Patinaje'}>Patinaje</MenuItem>
                                            <MenuItem key={8} value={'Tenis'}>Tenis</MenuItem>
                                            <MenuItem key={9} value={'Otros'}>Otros</MenuItem>
                                        </Select>
                                        <FormHelperText></FormHelperText>
                                    </FormControl>
                                </Col>
                            </>
                            : null}
                    </Row>
                </div>

                <Col>
                    <div>
                        <div>
                        </div>
                        <div className="half">

                            <div className="form">
                                <div className="card__title">
                                    <h5 className="bold-text">Información de Hábitos Nutricionales</h5>
                                </div>
                                <div className="form__form-group-field" >
                                    <textarea
                                        value={this.props.sectionAilment.habits.nutricional}
                                        disabled={this.props.stateClinicHistory}
                                        name="textarea-nutricional"
                                        style={{ width: '50%' }}
                                        onChange={(e) => {
                                            this.props.handlerHabits(
                                                "nutricional",
                                                e.target.value
                                            )
                                        }}
                                    >
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Card >
        );
    }
}

export default Habits;
